import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ItemService } from '../../../../services/item.service';
import { Item, ItemTransferHistory } from '../../../../models/Item';

@Component({
  selector: 'app-item-view',
  templateUrl: './item-view.component.html',
  styleUrls: ['./item-view.component.css']
})
export class ItemViewComponent implements OnInit {
  item: Item | null = null;
  itemId: number | null = null;
  loading = false;
  error: string | null = null;
  showTransferModal = false;
  transferHistory: ItemTransferHistory[] = [];
  loadingHistory = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private itemService: ItemService
  ) {}

  ngOnInit(): void {
    this.itemId = this.route.snapshot.params['id'];
    if (this.itemId) {
      this.loadItem();
      
      // Verificar se deve abrir o modal de transferência
      const action = this.route.snapshot.queryParams['action'];
      if (action === 'transfer') {
        // Aguardar o item carregar antes de abrir o modal
        setTimeout(() => {
          this.showTransferModal = true;
        }, 100);
      }
    } else {
      this.error = 'ID do item não fornecido';
    }
  }

  loadItem(): void {
    if (!this.itemId) return;

    this.loading = true;
    this.error = null;

    this.itemService.getItemById(this.itemId).subscribe({
      next: (item) => {
        this.item = item;
        this.loading = false;
        this.loadTransferHistory();
      },
      error: (error) => {
        this.error = 'Erro ao carregar item';
        this.loading = false;
        console.error('Erro ao carregar item:', error);
      }
    });
  }

  loadTransferHistory(): void {
    if (!this.itemId) return;

    this.loadingHistory = true;
    this.itemService.getTransferHistory(this.itemId, { page: 1, pageSize: 1000 }).subscribe({
      next: (result) => {
        this.transferHistory = result.items || [];
        this.loadingHistory = false;
      },
      error: (error) => {
        console.error('Erro ao carregar histórico de transferências:', error);
        this.loadingHistory = false;
      }
    });
  }

  editItem(): void {
    if (this.itemId) {
      this.router.navigate(['/stock/items', this.itemId, 'edit']);
    }
  }

  goBack(): void {
    this.router.navigate(['/stock/items']);
  }

  deleteItem(): void {
    if (!this.item) return;

    const confirmed = confirm(`Tem certeza que deseja excluir o item "${this.item.name}"?`);
    if (confirmed) {
      this.itemService.deleteItem(this.item.id).subscribe({
        next: () => {
          this.router.navigate(['/stock/items']);
          // TODO: Mostrar mensagem de sucesso
        },
        error: (error) => {
          console.error('Erro ao excluir item:', error);
          // TODO: Mostrar mensagem de erro
        }
      });
    }
  }

  transferItem(): void {
    this.showTransferModal = true;
  }

  closeTransferModal(): void {
    this.showTransferModal = false;
  }

  onTransferSuccess(): void {
    this.showTransferModal = false;
    this.loadItem(); // Recarregar dados do item
    this.loadTransferHistory(); // Recarregar histórico
    // TODO: Mostrar mensagem de sucesso
  }


  getStatusClass(status: string): string {
    switch (status.toLowerCase()) {
      case 'disponível':
        return 'bg-success';
      case 'em uso':
        return 'bg-warning';
      case 'danificado':
        return 'bg-danger';
      case 'vencido':
        return 'bg-danger';
      case 'em manutenção':
        return 'bg-info';
      case 'em trânsito':
        return 'bg-primary';
      default:
        return 'bg-secondary';
    }
  }

  getConditionClass(condition?: string): string {
    if (!condition) return 'condition-default';
    
    switch (condition.toLowerCase()) {
      case 'novo':
        return 'condition-new';
      case 'usado':
        return 'condition-used';
      case 'danificado':
        return 'condition-damaged';
      case 'reparado':
        return 'condition-repaired';
      default:
        return 'condition-default';
    }
  }

  formatDate(dateString?: string): string {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('pt-BR');
  }

  formatCurrency(value?: number, currencyCode?: string): string {
    if (value === undefined || value === null) return 'N/A';
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: currencyCode || 'BRL'
    }).format(value);
  }

  formatNumber(value?: number, decimals: number = 2): string {
    if (value === undefined || value === null) return 'N/A';
    return new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    }).format(value);
  }

  getTransferTypeClass(transferType?: string): string {
    switch (transferType?.toLowerCase()) {
      case 'complete':
        return 'bg-primary';
      case 'partial':
        return 'bg-warning';
      case 'location':
        return 'bg-info';
      default:
        return 'bg-secondary';
    }
  }

  getTransferTypeLabel(transferType?: string): string {
    switch (transferType?.toLowerCase()) {
      case 'complete':
        return 'Completa';
      case 'partial':
        return 'Parcial';
      case 'location':
        return 'Localização';
      default:
        return transferType || 'N/A';
    }
  }
}
